<template>
    <div class="play-video-wrapper">
        <!-- <layout :top="true" :hasBottom="false"> -->
        <div slot="head">
            <TopTabbar />
        </div>
        <div slot="content" class="con">
            <video
                :src="path"
                autoplay="autoplay"
                loop="loop"
            >
                您的浏览器不支持播放该视频！
            </video>
        </div>
        <!-- </layout> -->
    </div>
</template>
<script>
import layout from "@/components/layout.vue";
import TopTabbar from "@/components/TopTabbar.vue";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
    components: {
        layout,
        TopTabbar,
    },
    data() {
        return {
            list: [],
            path: ''
        };
    },
    created() {
        this.path = this.$route.query.path
    },
    methods: {
        Jump() {
            this.$router.push("/videoDetail");
        },
    },
};
</script>
<style lang="scss" scoped>
.play-video-wrapper {
    width: 100vw;
    height: 100vh;
}
.con {
    background: #000;
    width: 100vw;
    height: 100vh;
    video {
        width: 100vw;
        height: 100vh;
    }
}
</style>
